module.exports = __webpack_public_path__ + "img/loveman.1641520899224.png";